export const home = {
  hero: {
    title: 'Bringing Hope to Refugees in the Uganda',
    subtitle: 'Emergency aid, healthcare, education, and shelter for vulnerable communities',
    donateButton: 'Donate Now',
    learnMoreButton: 'Learn More',
  },
  impact: {
    badge: 'Our Impact',
    title: 'Changing Lives Every Day',
    subtitle: 'Real numbers behind real change — every figure represents a life touched, a family supported, and a future restored.',
    counters: {
      livesHelped: 'Lives Helped',
      livesHelpedDesc: 'Individuals and families who received direct humanitarian support',
      mealsProvided: 'Meals Provided',
      mealsProvidedDesc: 'Nutritious meals delivered to displaced families and children',
      sheltersBuilt: 'Shelters Built',
      sheltersBuiltDesc: 'Safe, dignified shelters constructed for displaced families',
      childrenEducated: 'Children Educated',
      childrenEducatedDesc: 'Children given access to quality education despite displacement',
    },
    growthTitle: 'Our Journey Over the Years',
    milestones: {
      founded: 'Founded',
      expanded: 'Expanded to 3 regions',
      clinics: '10 Mobile Clinics',
      schools: '25 Schools Supported',
      shelters: '8,400 Shelters Built',
    },
  },
  projects: {
    title: 'Our Active Projects',
    subtitle: 'Making a real difference in the lives of refugees and vulnerable communities through targeted programs and sustainable solutions.',
    viewProject: 'View Project',
    viewAll: 'View All Projects',
    active: 'Active',
    completed: 'Completed',
  },
  testimonials: {
    badge: 'Stories of Hope',
    title: 'Voices from the Field',
    subtitle: 'Hear from the people whose lives have been transformed through your support — in their own words, photos, and videos.',
    tabs: {
      all: 'All Stories',
      photo: 'Photo',
      video: 'Video',
      text: 'Text',
    },
  },
  news: {
    title: 'Latest News & Updates',
    subtitle: 'Stay informed about our recent activities, success stories, and field updates from the Democratic Republic of Congo',
    readMore: 'Read More',
    viewAll: 'View All News & Updates',
  },
  cta: {
    badge: 'Make a Difference Today',
    title: 'Your Support Can',
    titleItalic: 'Change Lives Forever',
    subtitle: 'Every donation, no matter the size, brings hope, dignity, and a brighter future to refugees and vulnerable communities in the Democratic Republic of Congo.',
    donateButton: 'Donate Now',
    secureText: 'Secure donation via Stripe & PayPal',
  },
};
